import SuspensedWithFallback from 'app/components/SuspensedWithFallback';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const Auth = React.lazy(() => import('features/auth/pages/Auth'));

const WebsiteLayout = React.lazy(
  () => import('features/website-layout/pages/WebsiteLayout')
);
const WebApp = React.lazy(() => import('features/web-app/pages/Layout'));

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/auth/*"
        element={
          <SuspensedWithFallback>
            <Auth />
          </SuspensedWithFallback>
        }
      />

      <Route
        path="/app/*"
        element={
          <SuspensedWithFallback>
            <WebApp />
          </SuspensedWithFallback>
        }
      />

      <Route path="/home" element={<Navigate to="/" />} />

      <Route
        path="/*"
        element={
          <SuspensedWithFallback>
            <WebsiteLayout />
          </SuspensedWithFallback>
        }
      />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
export default AppRoutes;
